import { useFormikContext } from 'formik';

import { Button } from '@/components/ui/button';

type DocumentUploadActionsProps = {
  onCancel: () => void;
  isLoading: boolean;
};

export function KnowledgeBaseActions({ onCancel, isLoading }: DocumentUploadActionsProps) {
  const { isValid } = useFormikContext();
  return (
    <div className="flex justify-end gap-2 pt-2">
      <Button variant="outline" onClick={onCancel} disabled={isLoading} className="px-3">
        Cancel
      </Button>
      <Button disabled={!isValid || isLoading} type="submit" className="px-3">
        {isLoading ? (
          <>
            <div className="w-4 h-4 border-2 border-primary-foreground border-t-transparent rounded-full animate-spin mr-2" />
            Creating
          </>
        ) : (
          <span>Create knowledge base</span>
        )}
      </Button>
    </div>
  );
}
